import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'
import {findByMail, get, postWithHeaders} from '../../../server/actions';
import {required, email, phoneNo} from '../../../server/validationMethods'
import NotificationSystem from 'react-notification-system';
import validate from 'validator';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import Select from 'react-select';
import {Link} from 'react-router-dom'
import {access_token} from "../../../server/constants";
import {BeatLoader} from 'react-spinners';
import {_addNotification, _addNotificationError, groupBy, getCountryCallCode, getModuleEnum} from "../../../server/util";
import Modal from 'react-modal';
import PaymentGatewayForm from './paymentGatewayForm';
import './schoolRegister.css';
let searchedSchool = [];
let formData = {};
let schoolId = '';
let newUser = false;
const styles={
    formControlXm:{
        height: '26px',
        padding: '2px 5px',
        fontSize: '12px',
        lineHeight: '0.328571'
    }
}
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '45%',
        transform: 'translate(-50%, -50%)'
    }
};
const modEnum=getModuleEnum();
class SchoolRegister extends Component{
    constructor(props){
        super(props);
        this.state={
            id:0,
            initStep:0,
            loading:false,
            schoolList:[],
            catererList:[],
            districtList:[],
            notOnBoardedSchools:[],
            onBoardedSchools:[],
            timeZoneList:[],
            schoolInfo:{},
            userInfo:[{}],
            allUsers:[],
            tierInfo:[],
            selectEmailModal:false,
            selectedEmail:'',
            gatewayOptions:[],
            userEmailErrors:{},
            deletePrimaryModal:false,
            selectedPrimaryUserData:{}
        }
    }
    getAllCatererList=()=>{
        return new Promise((resolve,reject)=>{
            get('/caterers?access_token=').then((response)=>{
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
            resolve({catererList: data._embedded.caterers||[]});
          }).catch(
              (error) => {
                  reject({catererList: []});
              }
          );
        })
    }
    getAllDistrictList=()=>{
        return new Promise((resolve,reject)=>{
            get('/districts?access_token=').then((response)=>{
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
            resolve({districtList: data._embedded.districts||[]});
          }).catch(
              (error) => {
                  reject({districtList: []});
              }
          );
        })
    }
    componentWillMount=()=>{
        let id = parseInt(this.context.router.route.match.params.id||0);
        this.setState({id: id });
        if((id||0)==0){
            Promise.all([
                this.getNotOnBoardedSchoolList(),
                this.getTiersData(),
                this.getPaymentGatewayOptions(),
                this.getAllCatererList(),
                this.getAllDistrictList()
            ]).then((res)=>{
                this.setState({
                    schoolList: res[0].schoolList||[], 
                    notOnBoardedSchools: res[0].notOnBoardedSchools||[],
                    tierInfo:res[1].tierInfoes,
                    gatewayOptions:res[2].gatewayOptions||[],
                    catererList: res[3].catererList.map(item=>{
                        const catererId=item._links.self.href.split('/').pop();
                            let primaryUser=item.catererUsers.filter(cate=>cate.isPrimaryUser===true)[0]||{};
                            return {...item,...primaryUser, value:catererId, label:item.name};
                        })||[],
                    districtList: res[4].districtList.map(item=>{
                            const dId=item._links.self.href.split('/').pop();
                            let primaryUser=item.districtUsers.filter(d=>d.isPrimaryUser===true)[0]||{};
                            return {...item,...primaryUser, value:dId, label:item.name};
                        })||[] 

                });
            });            
        }else{
            Promise.all([
                this.getNotOnBoardedSchoolList(),
                this.getOnBoardedSchoolList(),
                this.getTiersData(),
                this.getSchoolSelectedTierDataById(id),
                this.getPaymentGatewayOptions(),
                this.getAllCatererList(),
                this.getAllDistrictList()
            ]).then((res)=>{
                const tierInfoes=res[2].tierInfoes;
                const selectedTier=res[3].selectedTierData||{};
                const _catererId=res[3].caterer.id;
                const _districtId=(res[3].district||{}).id||0;
                const selectedPaymentGateway=res[3].selectedPaymentGateway;
                const index=tierInfoes.findIndex(tier=>{
                    return tier.tierName==selectedTier.tierName
                })
                if(index!==-1){
                    tierInfoes[index].isSelected=true;
                    tierInfoes[index].moduleInfos.map((mod,i)=>{
                        tierInfoes[index].moduleInfos[i].defOption= selectedTier.moduleAccess[mod.moduleName];
                    })
                }
                const _gatewayOptions=(res[4].gatewayOptions||[]).map(itm=>{
                    const id=(itm._links.self.href.split('/').pop());
                    const sgw=selectedPaymentGateway.find(s=>{
                        return s._links.paymentGateway.href.split('/').pop()==id
                    })
                    if(sgw){
                        const frmValues=itm.formValues;
                        const sgw_group=groupBy(sgw.formValues,'name');
                        frmValues.forEach(r=>{
                            r.value=((sgw_group[r.name]||[])[0]||{}).value||'';
                        })
                        return {...itm, id:id, formValues:frmValues, select:true}
                    }else{
                        return {...itm,id:id,select:false }
                    }                    
                })
                
                this.setState({
                    schoolList: res[0].schoolList||[], 
                    notOnBoardedSchools: res[0].notOnBoardedSchools||[],
                    onBoardedSchools:res[1].onBoardedSchools||[],
                    tierInfo:res[2].tierInfoes,
                    gatewayOptions:(_gatewayOptions||[]) ,
                    catererList: res[5].catererList.map(item=>{
                        const catererId=item._links.self.href.split('/').pop();
                        let primaryUser=item.catererUsers.filter(cate=>cate.isPrimaryUser===true)[0]||{};
                        return {...item,...primaryUser, value:catererId, label:item.name};
                    })||[],
                    districtList: res[6].districtList.map(item=>{
                        const dId=item._links.self.href.split('/').pop();
                        let primaryUser=item.districtUsers.filter(d=>d.isPrimaryUser===true)[0]||{};
                        return {...item,...primaryUser, value:dId, label:item.name};
                    })||[]             
                },()=>{
                    this.getSchoolInfoById(id,res[1].onBoardedSchools).then((res)=>{
                        this.setState({
                            schoolInfo:{...res.schoolInfo||{}, catererId:_catererId, districtId:_districtId},
                            userInfo: res.userInfo||[],
                            allUsers:res.allUsers,
                            timeZoneList:res.timeZoneList,                            
                        })
                    })
                    
                });
            });;
        }
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
    }
    getPaymentGatewayOptions=()=>{
        return new Promise((resolve,reject)=>{
            get('/paymentGateways?access_token=').then((response)=>{
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
            resolve({gatewayOptions: data._embedded.paymentGateways||[]});
          }).catch(
              (error) => {
                  reject({gatewayOptions: []});
              }
          );
        })
    }
    getTiersData=()=>{
        return new Promise((resolve, reject) => {
          get('/tierInfoes?access_token=').then((response) => {
              if (!response.ok) {
                  throw Error(response.statusText);
              }
              return response.json();
          }).then(data => {
              const tierList=data._embedded.tierInfoes.map(item=>{
                  item['isSelected']=false;
                  const modList=item.moduleInfos.map(mod=>{
                        mod.optionList=[];
                        mod.defOption='';
                      if(mod.options.length>0){
                          const list=(mod.options||'').split(',');
                          mod.optionList=list;
                          mod.defOption=list[0]||''
                      }
                      return mod;

                  })
                  item.moduleInfos=modList;
                  return item
              });
              resolve({tierInfoes: tierList||[]});
          }).catch(
              (error) => {
                  console.log('Get SchoolDistricts response', error);
                  reject({tierInfoes: []});
              }
          )
        });
      }
    getNotOnBoardedSchoolList=()=>{
      return new Promise((resolve, reject) => {
        get('/schools/search/findNotBoardedSchool?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let searchedSchool=[];
            data._embedded.schools.map(school => {
                const sid=school._links.self.href.split('/').pop()
                    searchedSchool.push({
                        label:school.schoolName + ', ' + school.county + ', ' + school.schoolDistrictName,
                        value:sid});
                }
            );
            
            resolve({schoolList: searchedSchool, notOnBoardedSchools:data._embedded.schools});
        }).catch(
            (error) => {
                console.log('Get SchoolDistricts response', error);
                reject({schoolList: [], notOnBoardedSchools:[]});
            }
        )
      });
    }
    getOnBoardedSchoolList=()=>{
        return new Promise((resolve, reject) => {
          get('/mealSchools/search/findByIsActive?isActive=true&page=0&size=2147483647&access_token=').then((response) => {
              if (!response.ok) {
                  throw Error(response.statusText);
              }
              console.log('response', response);
              return response.json();
          }).then(data => {
              resolve({onBoardedSchools : data._embedded.mealSchools});
          }).catch(
              (error) => {
                  console.log('Get SchoolDistricts response', error);
                  reject({onBoardedSchools : []});
              }
          )
        });
    }
    onSchoolChange=(value)=>{
        const selectedSchool=this.state.notOnBoardedSchools.find(school=>{
            const id=school._links.self.href.split('/').pop()
            return id==value.value;
        });
        if(selectedSchool){
            const formData=this.state.schoolInfo;
            formData.id = selectedSchool._links.school.href.split('/').pop();
            formData.schoolName = selectedSchool.schoolName;
            formData.schoolAddress=selectedSchool.schoolAddress;
            formData.countryCode=selectedSchool.countryCode;
            formData.cityStateZip=selectedSchool.cityStateZip;
            formData.county=selectedSchool.county;
            formData.schoolDistrictName=selectedSchool.schoolDistrictName;
            const _userInfo=this.state.userInfo;
            const code=getCountryCallCode(selectedSchool.countryCode);
            formData.schoolTimezone='';
            _userInfo.forEach((usr,i)=>{
                _userInfo[i]["code"]=code;
            });
            this.getTimeZones(selectedSchool.countryCode).then((data)=>{
                this.setState({schoolInfo:formData,userInfo:_userInfo, timeZoneList:(data.timeZoneList||[])});
            }).catch(ex=>{
                this.setState({schoolInfo:formData,userInfo:_userInfo, timeZoneList:[]});
            });
        }
    }
    onCatererChange=(value)=>{
        const selectedCaterer=this.state.catererList.find(c=>{
            return c.value==value.value;
        });
        if(selectedCaterer){
            const formData=this.state.schoolInfo;
            formData.catererId=selectedCaterer.value;
            this.setState({schoolInfo:formData});
        }        
    }
    onDistrictChange=(value)=>{
        const selectedDistrict=this.state.districtList.find(c=>{
            return c.value==value.value;
        });
        if(selectedDistrict){
            const formData=this.state.schoolInfo;
            formData.districtId=selectedDistrict.value;
            this.setState({schoolInfo:formData});
        }

    }
    onTimeZoneChange=(value)=>{
        const selectedTimeZone=this.state.timeZoneList.find(timeZone=>{
            return timeZone.value==value.value;
        });
        if(selectedTimeZone){
            const formData=this.state.schoolInfo;
            formData.schoolTimezone=selectedTimeZone.value;
            this.setState({schoolInfo:formData});
        }
    }
    onChangeUserData=(e,index)=>{
       const user= this.state.userInfo;
       user[index][e.target.name]=e.target.value;
       this.setState({userInfo:user},()=>{
           if(e.target.name==='username'){
               this.uniqueEmail(e.target.value,index);
           }
       });
    }
    getTimeZones=(countryCode)=>{
        return new Promise((resolve, reject) => {
        get('/countryDetails/search/findByCountryCode?countryCode='+countryCode+'&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let tzList=[];
            try{
                JSON.parse(data.timezoneInfo||[]).forEach(function(val){
                    tzList.push({label:val.timezoneName+' ('+ val.timezoneDesc+')',value:val.timezoneName});
                });
            }catch(ex){

            }            
            resolve({timeZoneList:tzList});
        })
            .catch(
                (error) => {
                    console.log('Onboard School response', error);
                    reject({timeZoneList:[]});
                }
            )
        });
    }
    onTierCheckedChanged=(e,index)=>{
        const _tierInfo=this.state.tierInfo.map(tier=>{
            tier.isSelected=false;
            return tier;
        });
        _tierInfo[index].isSelected=e.target.checked;
        this.setState({tierInfo:_tierInfo});
    }
    getSchoolSelectedTierDataById=(id)=>{
        return new Promise((resolve, reject) => {
            get('/mealSchools/'+id+'/?access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(res => {
                const tierData={tierName:res.tierName, moduleAccess:res.moduleAccess};
                resolve({
                    selectedTierData:tierData,
                    selectedPaymentGateway:res.paymentGateways||[],
                    caterer:{id:res.catererId},
                    district:{id:res.districtId}
                });
            }).catch(
                (error) => {
                    console.log('Get School data response', error);
                    reject({
                        selectedTierData:{},
                        selectedPaymentGateway:[],
                        caterer:{id:0},
                        district:{id:0}
                    });
                }
            )
        });
    }
    
    getSchoolInfoById=(id,onBoardedSchools)=>{
        return new Promise((resolve, reject) => {
            get('/mealSchools/'+id+'/school?access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(res => {
                const otherSchoolDetails=(onBoardedSchools||[]).find(school=>{
                   return (id)==(school._links.self.href.split('/').pop())
                })||{};

                let formdata = {};
                formdata.id=id;
                formdata.mealSchoolId = res._links.self.href.split('/').pop();
                formdata.cityStateZip = res.cityStateZip;
                formdata.county = res.county;
                formdata.schoolAddress = res.schoolAddress;
                formdata.schoolName = res.schoolName;
                formdata.countryCode = res.countryCode;
                formdata.schoolTimezone=otherSchoolDetails.schoolTimezone;
                formdata.trxFeeOnSchool=otherSchoolDetails.trxFeeOnSchool;
                formdata.appFee=otherSchoolDetails.appFee;
                const primUsers=(otherSchoolDetails.schoolUsers||[]).filter(usr=>{
                    return usr.isPrimaryUser
                })||{};
                const code=getCountryCallCode(res.countryCode);
                primUsers.forEach((usr,i)=>{
                    primUsers[i]["code"]=code;
                    primUsers[i]["phone"]=(usr.mobileNo||'').replace(code,'');
                });
                this.getTimeZones(res.countryCode).then((data)=>{
                    resolve({
                        schoolInfo:formdata,
                        userInfo: primUsers,
                        allUsers:(otherSchoolDetails.schoolUsers||[]),
                        timeZoneList:data.timeZoneList
                    });
                }).catch(ex=>{
                    resolve({
                        schoolInfo:formdata,
                        userInfo: primUsers,
                        allUsers:(otherSchoolDetails.schoolUsers||[]),
                        timeZoneList:[]
                    });

                })                
            }).catch(
                (error) => {
                    console.log('Get School data response', error);
                    reject({
                        schoolInfo:{},
                        userInfo: [],
                        allUsers:[]
                    });
                }
            )
        });
    }
    validateEmail = (username, resolve) => {
        findByMail(username).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(response => {
            if (response === true) {
                resolve();
            } else {
                document.getElementById("submit").disabled = false;
                this.setState({loading: false})
                document.getElementById(username).style.color = "red";
                document.getElementById(username).innerHTML = "Email id already registered!";
            }
        }).catch(
            (error) => {
                document.getElementById("submit").disabled = false;
                this.setState({loading: false})
            })
    }
    
     uniqueEmail=(value,index)=>{
        let res=undefined;
        let _userEmailErrors=this.state.userEmailErrors;
        if(value.length>4){
         get('/emailValidate?email='+value+'&type=&access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                if(data.statusCode==200){
                   delete _userEmailErrors[index];
                }else{
                    _userEmailErrors[index]=data.statusMessage
                    //res=(<span className="text-danger">{data.statusMessage}</span>);            
                }     
            }).catch(
                (error) => {
                    _userEmailErrors[index]='This email id already used for one of the user!!'
                    //res=(<span className="text-danger">This email id already used for one of the admin user!!</span>);                    
                }
            );            
        }else{
            delete _userEmailErrors[index];
        }
        this.setState({userEmailErrors:_userEmailErrors})
    }
    deleteModel=(user)=>{
        this.setState({ deletePrimaryModal: true,selectedPrimaryUserData: user })
    }
    deleteprimaryUser=()=>{
        let count =0
        this.state.userInfo.forEach((item)=>{
            if(item.isPrimaryUser){
                count++
            }

        })
        if(count===1){
            _addNotificationError("Sorry, you can't able to delete this user...", this);
            this.setState({ deletePrimaryModal: false,selectedPrimaryUserData: {} })
        }else{
           // delete call
           this.deleteUser()
        }
    }
    getDataSyncFieldMap=()=>{  
        this.setState({loading: true});      
        get('/mealSchools/' + this.state.id + '?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            console.log('data', data);
            this.setState({
                schoolList: data.schoolUsers ,
                loading: false
            })             
        }).catch(
            (error) => {  
                this.setState({loading: false});              
                console.log('Get Users data response', error)
            }
        );
    }
    deleteUser = () => {
        if(this.state.selectedPrimaryUserData.username){
            this.setState({loading: true});      
            const loggedInUserDetails = sessionStorage.getItem("loggedInUserDetails")
            get('/enableDisableSchoolUser?schoolUserName=' + this.state.selectedPrimaryUserData.username + '&activeStatus=false&loggedUser=' + JSON.parse(loggedInUserDetails).username + '&access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response;
            }).then(data => {
                this.setState({
                    loading: false,
                    deletePrimaryModal: false
                });
                _addNotification('Successfully deactivated admin.', this);
                //this.getSchoolList();
               
                this.getDataSyncFieldMap();
                window.location.reload();
                console.log('Access Links Sent', data);
            })
                .catch(
                    (error) => {
                        this.setState({
                            loading: false,
                            deletePrimaryModal: false
                        });
                        _addNotificationError('Deactivation failed. Please try again later.', this);
                        console.log('Send Notification Links response', error)
                    }
                )
        }
       
    }
    buildUserCard=(user,i)=>{
        return (<div className={user.isPaymentRegister? "card paymentCard":"card"} 
        style={{ border: "solid 5px #cccccc5c",  padding: "6px",  boxShadow: "none", marginBottom:'15px'}}>
            <div className="row">
                <div className="col-md-6">
                    <h5 className="card-title">Admin User</h5>
                </div>
                <div className="col-md-6">
                    {
                        user.isPaymentRegister ?
                         <span className="paymentNote"><i className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></i> Online Payment Enabled </span>
                         :  <a className="delete-btn paymentNote"
                           ><i
                          className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon" 
                          onClick={()=>this.deleteModel(user)}/></a>
                    }      
                </div>
            </div>
        
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group col-md-6 col-sm-12">
                        <label htmlFor={"txtFirstName"+i}>First Name*</label>
                        <Input type="text" 
                        className="form-control" 
                        validations={[required]}
                        id={"txtFirstName"+i} requiredmsg="User first name required"
                        name="firstName" value={user.firstName} 
                        onChange={(e)=>{this.onChangeUserData(e,i)}} />
                    </div>
                    <div className="form-group col-md-6 col-sm-12">
                        <label htmlFor={"txtLastName"+i}>Last Name*</label>
                        <Input type="text" 
                        className="form-control" id={"txtLastName"+i} 
                        requiredmsg="User last name required"
                        validations={[required]}
                        name="lastName" value={user.lastName} onChange={(e)=>{this.onChangeUserData(e,i)}} />
                    </div>
                    <div className="form-group col-md-6 col-sm-12" style={{zIndex: '0'}}>
                        <label htmlFor={"txtPhone"+i} >Phone</label>
                        <div className="input-group">                                                    
                            <span className="input-group-addon">{user.code}</span>
                            <Input type="text" className="form-control" id={"txtPhone"+i} 
                            requiredmsg="User Phone no required"
                            validations={[phoneNo]}
                            maxLength={10}
                            name="phone" value={user.phone} onChange={(e)=>{this.onChangeUserData(e,i)}} />
                        </div>
                    </div>
                    <div className="form-group col-md-6 col-sm-12">
                        <label htmlFor={"txtEmail"+i}>Email Id*</label>
                        <Input type="email" className="form-control" id={"txtEmail"+i}                       
                        requiredmsg="User email required" disabled={this.state.id!=0}
                        validations={[required, email]} 
                        onBlur={(e)=>{
                            this.uniqueEmail(e.target.value,i)
                        }}
                        name="username" value={user.username} 
                        onChange={(e)=>{this.onChangeUserData(e,i)}} />
                        {
                            (this.state.userEmailErrors||{})[i]? <span style={{fontSize:'11px'}} className="text-danger">{this.state.userEmailErrors[i]}</span>:
                            <span></span>
                        }
                    </div>
                    <div className="form-group col-md-12 col-sm-12">
                        <div className="checkbox">
                            <label>
                                <input type="checkbox" checked={user.isUnsubscribeGenNotif} 
                                name="isUnsubscribeGenNotif" onChange={(e)=>{
                                    const user= this.state.userInfo;
                                    user[i]['isUnsubscribeGenNotif']=e.target.checked;
                                    this.setState({userInfo:user});
                                }} /> Unsubscribe For General Notifications
                            </label>
                        </div>                                    
                    </div>                                  
                </div>
            </div>
        </div>);
    }
    checkPaymentSelected=()=>{
        const selectedTier=this.state.tierInfo.find(tier=>{
            return tier.isSelected===true;
        })
        if(selectedTier){
            const paymentmodules= selectedTier.moduleInfos.filter(mod=>{
                return mod.moduleName === modEnum.APO || mod.moduleName === modEnum.IPFO || mod.moduleName === modEnum.BACP
            });
            const paymentActive=(paymentmodules||[]).some(itm=>{
                return itm.defOption === 'Yes'
            });
            return paymentActive;
        }
        return false;
        
    }
    saveSchoolObject=(event)=>{
        event.preventDefault();  
        const selectedTier=this.state.tierInfo.find(tier=>{
            return tier.isSelected===true;
        })
        if(!selectedTier){
            _addNotificationError('Please select plan', this);
            return false;
        }
        
        if(this.checkPaymentSelected()){
            this.setState({initStep:1});
        }else{
            this.handleSubmit(event);
        }
    }
    handleSubmit(event) {
        event.preventDefault();    
        let formData= this.state.schoolInfo;
        const users=this.state.userInfo;
        let allUsers=this.state.allUsers;
        const selectedTier=this.state.tierInfo.find(tier=>{
            return tier.isSelected===true;
        })
        if(!selectedTier){
            _addNotificationError('Please select plan', this);
            return false;
        }
        if(Object.keys(this.state.userEmailErrors).length>0){
            _addNotificationError("Please provide unique user email id's", this);
            return false;
        }
        this.setState({loading: true});
        formData.loggedUser = sessionStorage.getItem("loggedInUserInfo");
        formData.countryCode=formData.countryCode;
        formData.catererId=formData.catererId;
        formData.tierName=selectedTier.tierName;
        formData['paymentGateways']=[];
        const moduleAccess={};
        selectedTier.moduleInfos.map(mod=>{
            moduleAccess[mod.moduleName]=mod.defOption;
        });
        if(this.checkPaymentSelected()){
            formData['isPaymentEnabled']=true;
            const selectedGateway=this.state.gatewayOptions.find((itm)=>{
                return itm.select===true
            })
            if(selectedGateway){
                formData['paymentGateways'].push({
                    "paymentGateway":{"id":selectedGateway.id},
                    "formValues":selectedGateway.formValues
                });
            }else{
                formData['isPaymentEnabled']=false;
            }
        }else{
            formData['isPaymentEnabled']=false;
        }
        if((formData.mealSchoolId||0) === 0){
            formData.school="/mealManage/schools/"+formData.id;
            users[0]['isPrimaryUser']=true;
            users[0]['mobileNo']=users[0].code+''+users[0].phone;
            users[0]['role']='ROLE_ADMIN';
            users[0]['isActive']=true;
            users[0]['isPaymentRegister']=false;
            users[0]['isUnsubscribeGenNotif']=users[0].isUnsubscribeGenNotif||false;
            if(formData['isPaymentEnabled']===true){
                users[0]['isPaymentRegister']= true;
            }
        }else{
            if(formData['isPaymentEnabled']===true){               
                if(users.length<=1){
                    users.forEach((usr,i)=>{
                        users[i]['mobileNo']=usr.code+''+usr.phone;
                        users[i]['isPaymentRegister']=true;
                    });
                }else{
                    let res= users.some(usr=>{
                        return usr.isPaymentRegister
                    });
                    if(res!== true){
                        this.setState({selectEmailModal:true});
                        return false;
                    }
                }    
                users.forEach((usr,i)=>{
                    users[i]['mobileNo']=usr.code+''+usr.phone;
                })
            }else{
                users.forEach((usr,i)=>{
                    users[i]['mobileNo']=usr.code+''+usr.phone;
                    users[i]['isPaymentRegister']=false;
                });
            }               
        }
        if(allUsers.length>0){
            const groupbyUsers=groupBy(users,'displayRecId');
            allUsers.forEach((usr,i)=>{
                if(usr.isPrimaryUser){
                    allUsers[i]=groupbyUsers[usr.displayRecId][0];
                }
            });
        }else{
            allUsers=users;
        }
        formData.schoolUsers = allUsers;
        formData.moduleAccess=moduleAccess;
        if ((formData.mealSchoolId||0) !== 0){
            let mealschoolid = formData.mealSchoolId
           // formData.schoolUsers = [];
            let body = JSON.stringify(formData);
            let headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            
            postWithHeaders('/mealSchoolUpdate?mealSchoolId=' + formData.id + '&access_token=', JSON.stringify(formData), headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            }).then(data => {
                get('/adminAccActivationInfo?schoolId=' + formData.id + '&loggedUser=' + formData.loggedUser + '&access_token=').then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    console.log('response', response);
                    return response;
                }).then(data => {
                    _addNotification('Successfully updated school data.', this);
                    this.setState({loading: false});
                    setTimeout(() =>
                            this.context.router.history.push('/SuperAdmin/schoolList')
                        , 3000);
                    console.log('Access Links Sent', data);
                })
                    .catch(
                        (error) => {
                            this.setState({loading: false});                            
                            _addNotificationError('Could not updated school data.', this);
                            console.log('Onboard School response', error)
                        }
                    )
                })
                .catch(
                    (error) => {
                        this.setState({loading: false});
                        _addNotificationError('Could not updated school data.', this);
                        console.log('Onboard School response', error)
                    }
                )      
            }
            else {
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                };
                postWithHeaders('/mealSchools?access_token=', JSON.stringify(formData), headers).then((response) => {
                        if (!response.ok) {
                            throw Error(response.statusText);
                        }
                        console.log('response', response);
                        return response.json();
                    }).then(res => {
                        let mealSchoolId = res._links.mealSchool.href.split('/').pop();
                        // <!--Send Admin activation Links-->
                        get('/adminAccActivationInfo?schoolId=' + mealSchoolId + '&loggedUser=' + formData.loggedUser + '&access_token=').then((response) => {
                            if (!response.ok) {
                                throw Error(response.statusText);
                            }
                            console.log('response', response);
                            return response;
                        }).then(data => {
                            _addNotification('New School Onboarded Successfully.', this);
                            this.setState({loading: false});
                            setTimeout(() => {
                                this.context.router.history.push('/SuperAdmin/schoolList')
                            }, 3000);
                            console.log('Access Links Sent', data);
                        })
                            .catch(
                                (error) => {
                                    console.log('Onboard School response', error)
                                }
                            )
                    }).catch(
                        (error) => {
                            this.setState({loading: false});                            
                            _addNotificationError('Failed to onboard new school.', this);
                            console.log('Add School response', error)
                        }
                    )

            }
    }
    render(){
        const school=this.state.schoolInfo;
        return(<Fragment>
            <div className="container">
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="panel panel-info">
                    <div className="panel-heading text-center">
                        <h3 className="panel-title">
                            <span>{this.props.school.actionType !== "EDIT" ? 'Onboard - New School' : 'Update School  '}</span>
                        </h3>
                    </div>                
                <div className="panel-body panel-body-onboard">
                    <NotificationSystem ref="notificationSystem"/>
                    { 
                        this.state.initStep ===0 &&
                    <Form ref={c => { this.form = c }} onSubmit={(e)=>{this.saveSchoolObject(e)}}>
                    
                        <Fragment>
                            <div className="row">
                                <div className="col-md-6 col-md-offset-3 col-sm-12">
                                    <div children="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="txtSchoolName">Search School*</label>
                                                { this.state.id==0? 
                                                    <Select
                                                        value={this.state.schoolList.find(itm=>{
                                                        return itm.value==school.id;
                                                    })}
                                                        label="Search School"
                                                        options={this.state.schoolList}
                                                        onChange={this.onSchoolChange}
                                                    /> :
                                                    <input type="text" disabled={true} className="form-control"                                             
                                                    value={school.schoolName} />
                                                }
                                                <Input type="text" style={{display:'none'}} 
                                                    className="form-control" 
                                                    validations={[required]}
                                                    requiredmsg="Please select School"
                                                    value={school.schoolName} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="txtTimezone">Time zone*</label>
                                                <Select
                                                    value={this.state.timeZoneList.find(itm=>{
                                                        return itm.value==school.schoolTimezone;
                                                    })}
                                                    label="Time zone"
                                                    onChange={this.onTimeZoneChange}
                                                    options={this.state.timeZoneList}
                                                />
                                                <Input type="text" style={{display:'none'}} 
                                                    className="form-control" 
                                                    validations={[required]}
                                                    requiredmsg="Please select Time zone"
                                                    value={school.schoolTimezone} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="txtDistrict">District</label>
                                                <Select
                                                    value={this.state.districtList.find(itm=>{
                                                        return itm.value==school.districtId;
                                                    })}
                                                    label="District"
                                                    onChange={this.onDistrictChange}
                                                    options={this.state.districtList}
                                                />
                                                <Input type="text" style={{display:'none'}} 
                                                    className="form-control"
                                                    value={school.districtId} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="txtCaterer">Caterer</label>
                                                <Select
                                                    value={this.state.catererList.find(itm=>{
                                                        return itm.value==school.catererId;
                                                    })}
                                                    label="Caterer"
                                                    onChange={this.onCatererChange}
                                                    options={this.state.catererList}
                                                />
                                                <Input type="text" style={{display:'none'}} 
                                                    className="form-control"
                                                    value={school.catererId} />
                                            </div>
                                        </div>                        
                                    </div>
                                </div>
                                <div className="col-md-12  col-sm-12">
                                    <div children="row">
                                        {
                                            (this.state.userInfo).length<=1?
                                            <div className="col-md-6 col-md-offset-3 col-sm-12">
                                                {
                                                    this.buildUserCard(this.state.userInfo[0],0)
                                                }
                                            </div>:                                            
                                            (this.state.userInfo.filter(u=>u.isActive)).map((usr,i)=>{
                                                const activeLength=(this.state.userInfo.filter(u=>u.isActive)).length;
                                                const idx=(this.state.userInfo.findIndex(u=>u.username===usr.username));
                                                if(idx>=0){
                                                    if(usr.isActive){
                                                        return <div className={activeLength===1?'col-md-6 col-md-offset-3 col-sm-12':"col-md-6 col-sm-12"}>
                                                        {
                                                            this.buildUserCard(usr,idx)
                                                        }
                                                    </div>
                                                    }else{
                                                        return null
                                                    }
                                                }else{
                                                    return null
                                                }
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="col-md-12  col-sm-12">
                                    <div children="row">
                                        <div className="col-md-12">
                                            <div className="panel-group" style={{fontSize:'12px'}}> 
                                                <div className="row">
                                                {
                                                    this.state.tierInfo.map((tier,i)=>{
                                                        return(
                                                            <div className="col-md-4">
                                                                <div className="panel-default">
                                                                    <div className="panel-heading" 
                                                                        style={{padding: '7px 7px', marginBottom:'7px', backgroundColor:'#D2D7D4'}}>
                                                                    <div className="checkbox">
                                                                                <label>
                                                                                    <input type="checkbox" checked={tier.isSelected} onChange={(e)=>{this.onTierCheckedChanged(e,i)}} /> {tier.tierName}
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="panel-body" id={"accordionChild"+i} style={{"padding": "0px", backgroundColor: "#ffffff", borderRadius:"0px"}}>
                                                                        <fieldset disabled={!tier.isSelected}>
                                                                        {
                                                                            tier.moduleInfos.map((mod,k)=>{
                                                                                return(                                                                        
                                                                                    <div className="form-group">
                                                                                        <div className="row">
                                                                                            <div  className={ mod.options.length>0? "col-md-8":"col-md-12"}>                                                                                   
                                                                                                {mod.moduleName}                                                                                
                                                                                            </div>
                                                                                    {
                                                                                        mod.optionList.length>0?
                                                                                        <div className="col-md-4">
                                                                                            <select className="form-control" style={styles.formControlXm} value={mod.defOption}
                                                                                            onChange={(e)=>{
                                                                                                const _tierInfo=this.state.tierInfo;
                                                                                                _tierInfo[i].moduleInfos[k]['defOption']=e.target.value;
                                                                                                this.setState({tierInfo:_tierInfo})
                                                                                            }}>
                                                                                            {
                                                                                                mod.optionList.map((opt,j)=>{
                                                                                                return <option key={j} value={opt}>{opt}</option>})
                                                                                            }
                                                                                            </select>
                                                                                        </div>
                                                                                        : null                                                                         
                                                                                    }
                                                                                    </div>                                                                           
                                                                                </div>)
                                                                            })
                                                                        } 
                                                                        </fieldset>
                                                                    </div>
                                                                    <div className="panel-footer" style={{backgroundColor: "#ffffff"}}>
                                                                    </div>                
                                                                </div>
                                                        )
                                                        })
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <div className="panel-footer" style={{backgroundColor: "#ffffff"}}>
                                <div className="row">
                                    <div className="col-md-12 text-right">
                                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }} onClick={(e)=>{
                                            
                                            this.context.router.history.push('/SuperAdmin/schoolList');

                                        }}>
                                            <i className="glyphicon glyphicon-remove" style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                        </button>
                                        <Button className="btn btn-success btn-xs" style={{ margin: '0 0 0 5px' }}>
                                        <i className="glyphicon glyphicon-ok" style={{ marginRight: '0', paddingLeft: '0' }}></i>{this.checkPaymentSelected()?' Next':' Save'}
                                        </Button>
                                    </div>                    
                                </div>
                            </div>
                            <Modal
                            isOpen={this.state.selectEmailModal}                       
                            style={deleteStyles}
                            contentLabel="Publish">
                                <div className="modal-header">
                                    <h4 className="modal-title modal-title-color" id="deleteLabel">Select Email For Payment Setup </h4>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>Select one email id from below list for payment setup</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <ul class="list-group">
                                                {this.state.userInfo.map((user, idx) => {
                                                    return (
                                                        <li class="list-group-item">
                                                            <input type="radio" name="paymentEmail" checked={user.username===this.state.selectedEmail}
                                                            onChange={(e)=>{
                                                                let users=this.state.userInfo; // 'isPaymentRegister'                                                                                                          
                                                                this.setState({selectedEmail: users[idx].username })
                                                            }} />
                                                            <label>{user.username}</label>
                                                        </li>)
                                                    })
                                                }
                                            </ul>                                        
                                        </div>
                                    </div>          
                                </div>
                                <div className="text-right">
                                    <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                        onClick={() => {    
                                            this.setState({selectedEmail: '',
                                                selectEmailModal:false})
                                                }}>
                                        <i className="glyphicon glyphicon-remove"
                                            style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                    </button>
                                    <button type="button" className="btn btn-success btn-xs"
                                        style={{ margin: '0 0 0 5px' }} onClick={()=>{
                                            if(this.state.selectedEmail.trim()!==''){
                                                let users=this.state.userInfo;
                                                let idx=users.findIndex((user)=>{
                                                    return user.username==this.state.selectedEmail
                                                });
                                                users[idx]['isPaymentRegister']=true;
                                                this.setState({selectEmailModal:false, userInfo:users})
                                                }                                             
                                        }}
                                        id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                                    </button>
                                </div>
                            </Modal>
                        </Fragment>
                        </Form>
                    }
                    { this.state.initStep===1 &&
                    <Fragment>
                     <div className="row">
                        <div className="col-md-12">
                            <PaymentGatewayForm schoolInfo={this.state.schoolInfo}
                                gatewayOptions={this.state.gatewayOptions}
                                onPaymentOptionChange={(e,index)=>{
                                    const _gatewayOptions=this.state.gatewayOptions;
                                    _gatewayOptions.forEach(itm=>{
                                        itm.select=false;
                                    });
                                    _gatewayOptions[index].select=(e.target.checked?true:false);
                                    this.setState({gatewayOptions:_gatewayOptions})
                                }}
                                onChangePaymentFormFieldValue={(e,index)=>{
                                    const _gatewayOptions=this.state.gatewayOptions;
                                    const selectedIndex=this.state.gatewayOptions.findIndex(g=>{
                                        return g.select===true;
                                    });
                                    if(selectedIndex!==-1){
                                        _gatewayOptions[selectedIndex].formValues[index].value=e.target.value;
                                    }
                                    this.setState({gatewayOptions:_gatewayOptions});
                                }}
                                onStripeChargesFromMurchant={(e)=>{
                                    const {schoolInfo}=this.state;
                                    schoolInfo.trxFeeOnSchool=e.target.checked;
                                    this.setState({schoolInfo:{...schoolInfo}})
                                }}
                                onStripeAppFeeChange={(e)=>{
                                    const {schoolInfo}=this.state;
                                    schoolInfo.appFee=e.target.value;
                                    this.setState({schoolInfo:{...schoolInfo}});
                                }}
                            />
                        </div>
                    </div>
                    <div className="panel-footer" style={{backgroundColor: "#ffffff"}}>
                        <div className="row">
                            <div className="col-md-12 text-right">
                                <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }} onClick={(e)=>{                                    
                                    this.setState({initStep:0})
                                }}>
                                    <i className="glyphicon glyphicon-remove" style={{ marginRight: '0', paddingLeft: '0' }}></i> Back
                                </button>
                                <button 
                                    className="btn btn-success btn-xs" 
                                    style={{ margin: '0 0 0 5px' }}
                                    onClick={(e)=>{
                                        this.handleSubmit(e);
                                    }}>
                                <i className="glyphicon glyphicon-ok" style={{ marginRight: '0', paddingLeft: '0' }}></i> Save
                                </button>
                            </div>                    
                        </div>
                    </div>
                    </Fragment>
                   }                    
                </div>
            </div>
        </div>
        <Modal
                        isOpen={this.state.deletePrimaryModal}
                       // onRequestClose={() => this.setState({restoreConformModal: false})}
                        style={modalStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                        
                                <div className="modal-body">
                                    <p>Are you sure you want to delete?</p>
                                </div>
                                <div className="text-right">
                                    <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                        onClick={() => this.setState({ deletePrimaryModal: false})}><i
                                            className="glyphicon glyphicon-remove"
                                            style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                    </button>
                                    <button type="button" className="btn btn-success btn-xs" 
                                        style={{ margin: '0 0 0 5px' }} onClick={()=>this.deleteprimaryUser()}
                                        id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                                    </button>
                                </div>
                    </Modal>
    </Fragment>);
    }
}
SchoolRegister.contextTypes = {
    router: PropTypes.object.isRequired
}
export default SchoolRegister


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/AddSchool/schoolRegister.jsx